/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import SwitchSelector from "react-switch-selector";
import AccordionBike from '../components/Accordion';
import { useProductos } from '../hooks/useProductos';
import { useAuth } from '../hooks/useAuth';
import { Link } from 'react-router-dom';
import { routes } from '../helpers/Routes';



import fuoco_gray from '../assets/bikes-slider/fuoco-gray.jpg'
import fuoco_white from '../assets/bikes-slider/fuoco-white.jpg'
import fuoco_blue from '../assets/bikes-slider/fuoco-blue.jpg'

import siluro_white from '../assets/bikes-slider/siluro-white.jpeg'
import siluro_gray from '../assets/bikes-slider/siluro-gray.jpeg'
import siluro_black from '../assets/bikes-slider/siluro-black.jpeg'



const SlideHome = ({ homeProducts }) => {
    const { usuario } = useAuth();
    const { productos, formatoCOP } = useProductos();
    const [isSwapped, setIsSwapped] = useState(false)
    const [buttonActive, setButtonActive] = useState(1)
    const [heightBici, setHeightBici] = useState(1)
    const [productslider1, setProductSlider1] = useState(null)
    const [productslider2, setProductSlider2] = useState(null)
    const [names, setNames] = useState(null)

    const [imagesProduct1, setImagesProduct1] = useState([])
    const [imagesProduct2, setImagesProduct2] = useState([])
    useEffect(() => {
        
        const homeProductsFind = homeProducts?.filter(pr => pr.assign == "slider")
        const productid1 = homeProductsFind?.find(pr => pr.description == "1")
        const productid2 = homeProductsFind?.find(pr => pr.description == "2")
        setNames({
            first: productid1?.text,
            second: productid2?.text
        })
        
        try {
            setImagesProduct1(JSON.parse(productid1?.tallas))
            setImagesProduct2(JSON.parse(productid2?.tallas))
        } catch (error) {
            setImagesProduct1([])
            setImagesProduct2([])
        }
       

        const product1 = productos.find(pr => pr.id == productid1?.productoid)
        const product2 = productos.find(pr => pr.id == productid2?.productoid)
        setProductSlider1(product1)
        setProductSlider2(product2)
    }, [homeProducts])
    const image1 = [
        {
            secure_url: fuoco_white
        },
        {
            secure_url: fuoco_blue
        },
        {
            secure_url: fuoco_gray
        },
    ]
    const image2 = [
        {
            secure_url: siluro_white
        },
        {
            secure_url: siluro_gray
        },
        {
            secure_url: siluro_black
        }
    ]
    const producto1 = productos?.find(i => i?.nombre === "Bicicleta de Ruta JAVA Fuoco Top")
    const producto2 = productos?.find(i => i?.nombre === "Bicicleta de Ruta JAVA Siluro 6 Top")
    
    const data = !isSwapped ? {
        description: {
            h1: `${productslider1?.nombre}`,
            peso: `${productslider1?.peso}`,
            tenedor: `${productslider1?.tenedor}`,
            tipoDeMarco: `${productslider1?.tipo_marco}`,
            tamañoDeLasLlantas: ``,
            frenos: `${productslider1?.frenos}`,
            grupo: `${productslider1?.grupo}`,
            manubrio: `${productslider1?.manubrio}`,
            tamañoDelMarco: `${productslider1?.tamaño_marco}`
        },
        id: `${productslider1?.id}`,
        dimensions: productslider1 ? JSON.parse(productslider1?.tallas)?.map(ta => ta.name) : [],
        heights: [450, 480, 500, 520],
        price: `${productslider1?.precio}`,
        peso: `${productslider1?.peso}`,
        bikes: productslider1 ? imagesProduct1?.map((data, index) => {
            return {
                id: index + 1, // Asigna un id único basado en el índice
                color: data.color,
                image: data?.url?.secure_url
            };
        }) : []

    } :
        {
            description: {
                h1: `${productslider2?.nombre}`,
                peso: `${productslider2?.peso}`,
                tenedor: `${productslider2?.tenedor}`,
                tipoDeMarco: `${productslider2?.tipo_marco}`,
                tamañoDeLasLlantas: ``,
                frenos: `${productslider2?.frenos}`,
                grupo: `${productslider2?.grupo}`,
                manubrio: `${productslider2?.manubrio}`,
                tamañoDelMarco: `${productslider2?.tamaño_marco}`
            },
            id: `${productslider2?.id}`,
            dimensions: productslider2 ? JSON.parse(productslider2?.tallas)?.map(ta => ta.name) : [],
            heights: [450, 480, 500, 520],
            price: `${productslider2?.precio}`,
            peso: `${productslider2?.peso}`,
            bikes: productslider2 ? imagesProduct2?.map((data, index) => {
                return {
                    id: index + 1, // Asigna un id único basado en el índice
                    color: data.color,
                    image: data?.url?.secure_url
                };
            }) : []
        }


    useEffect(() => {
        setButtonActive(1)
        setHeightBici(data.heights[0])
    }, [isSwapped]);

    const handleSwap = () => {
        setIsSwapped(!isSwapped)
    }

    const [size, setSize] = useState('');

    return (
        <section className='section-bike' style={{ marginBottom: "400px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} className="container-bike-selector-marcas">
                <div></div>
                <h2 style={{ fontSize: "34px", color: "#fff", transition: ".4s" }} className="bike-h2">{data.description.h1}</h2>
                <div style={{ height: 40, width: 120, marginRight: "70px"}} className="margin-select">
                    <SwitchSelector
                        backgroundColor={"#ccc"}
                        selectedBackgroundColor={"#000"}
                        // selectedFontColor={"000"}
                        
                        initialSelectedIndex={0}
                        onChange={() => handleSwap()}
                        options={[
                            {
                                label: names?.first,
                                value: "fuoco"
                            },
                            {
                                label: names?.second,
                                value: "siluro"
                            }
                        ]}
                    />
                </div>
            </div>

            <div className="container-bike container-bike-component">
                <div className="bike">
                    <motion.div
                        className="child"
                        style={{ marginTop: "180px", color: "#000" }}
                        initial={{ right: 0, opacity: 1 }}
                        animate={{ right: isSwapped ? "calc(100% - 627px)" : 0, opacity: isSwapped ? [0.6, 0.0, 0, 0.4, 0.6, 1] : [1, 0.6, 0, 0.0, 0.4, 0.6, 1] }}
                        transition={{
                            duration: .8,
                            times: [0, 0.4, 0.6, 1],
                            ease: "easeInOut",
                        }}
                    >

                        <img src={data?.bikes?.find(i => i?.id == buttonActive)?.image} alt="" style={{ marginLeft: "30px", width: "700px", height: "400px", marginRight: isSwapped ? "30px" : "0", marginTop: "80px", paddingBottom: "30px", objectFit: "contain" }} />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div className="staff-container">
                                <div className='section-staff'>
                                    <span>Precio: </span>
                                    <span>{formatoCOP.format(data?.price)}</span>
                                </div>
                                <div className='section-staff' style={{ display: "flex", alignItems: "center" }}>
                                    <span>Marco: </span>
                                    <span style={{ marginLeft: "10px" }}>{data?.description.tipoDeMarco}</span>
                                </div>
                                <div className='section-staff'>
                                    <span>Grupo: </span>
                                    <span style={{ marginLeft: "10px" }}>{data?.description.grupo}</span>
                                </div>
                            </div>
                        </div>

                    </motion.div>

                    <motion.div
                        className="child"
                        style={{ marginTop: "160px", width: "400px" }}
                        initial={{ left: 0, opacity: 1 }}
                        animate={{ left: isSwapped ? "calc(100% - 528px)" : 0, }}
                        transition={{
                            duration: .8,
                            times: [0, 0.4, 0.6, 1],
                            ease: "easeInOut"
                        }}
                    >
                        <AccordionBike data={data} setSize={setSize} />
                        <div>
                            <div className="buttons-color" style={{ marginTop: "30px" }}>
                                {data?.bikes?.map(data => (
                                    <button key={data?.id} style={{ backgroundColor: data?.color }} onClick={() => setButtonActive(data?.id)} className={`${buttonActive == data?.id ? "button-active" : ""}`} />
                                ))}
                            </div>

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                                <Link className="cart-add-button" style={{ textAlign: "center" }} to={isSwapped ? `${routes.producto + "/" + data?.id}` : `${routes.producto + "/" + data?.id}`}>Ver más</Link>
                            </div>
                        </div>
                    </motion.div>

                </div>

                <div className='bike-responsive' style={{ display: "none" }}>
                    <AnimatePresence mode="wait">
                        {!isSwapped ? (
                            <motion.img
                                key="image2"
                                src={data?.bikes?.find(i => i?.id == buttonActive)?.image}
                                alt="Imagen 2"
                                className="image-bike-responsive"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        ) : (
                            <motion.img
                                key="image1"
                                src={data?.bikes?.find(i => i?.id == buttonActive)?.image}
                                alt="Imagen 1"
                                className="image-bike-responsive"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        )}
                    </AnimatePresence>
                    <div className="buttons-color" style={{ marginTop: "30px" }}>
                        {data?.bikes?.map(data => (
                            <button key={data?.id} style={{ backgroundColor: data?.color }} onClick={() => setButtonActive(data?.id)} className={`${buttonActive == data?.id ? "button-active" : ""}`} />
                        ))

                        }
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                        <Link className="cart-add-button" style={{ textAlign: "center" }} to={isSwapped ? `${routes.producto + "/" + data?.id}` : `${routes.producto + "/" + data?.id}`}>Ver más</Link>
                    </div>

                </div>
            </div>
        </section >

    )
}

export default SlideHome;